export default "__VITE_ASSET__B0PtAk8A__"